import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'

const useGeneratePDF = (componentRefToPrint, onFinish) => {
    // This hook can be used to generate a PDF from a React component
    // You can pass the component you want to print as a parameter
    // and use the reactToPrint function to handle the printing process
    if (!componentRefToPrint) throw new Error('Component to print is required for this function to work!')
    const reactToPrint = useReactToPrint({
        contentRef: componentRefToPrint,
        documentTitle: 'Realtime Laser Safety Software',
        // onAfterPrint: () => {
        //     if (onFinish) onFinish()
        // },
    })

    return { reactToPrint }
}

export default useGeneratePDF
